import { useMemo } from 'react';
import {
  getInstitutionalConcepts,
  createInstitutionalConcept,
  updateInstitutionalConcept,
  setInstitutionalConceptActive,
  type ReviewOrganization,
} from '@urbanik/api-client';
import { StatePanel, canonicalStates } from '@urbanik/ui';
import { ConceptsView, type ConceptsTransport } from './ConceptsView';
import { reviewApiBase } from './api-base';
export function InstitutionalConceptsPanel({ organization }: { organization: ReviewOrganization }) {
  const transport = useMemo<ConceptsTransport>(
    () => ({
      list: (signal) => getInstitutionalConcepts(reviewApiBase, organization.id, signal),
      create: (draft) => createInstitutionalConcept(reviewApiBase, organization.id, draft),
      update: (id, draft) => updateInstitutionalConcept(reviewApiBase, organization.id, id, draft),
      status: (concept) =>
        setInstitutionalConceptActive(
          reviewApiBase,
          organization.id,
          concept.id,
          !concept.active,
          concept.version,
        ),
    }),
    [organization.id],
  );
  const allowed = (action: string) =>
    organization.permissions.includes('governance.concepts.' + action);
  return (
    <section aria-label={'Conceptos de ' + organization.name}>
      <h2>{organization.name}</h2>
      <p>
        Entidad: {organization.code} · {organization.id} · Solo ensayo
      </p>
      {allowed('read') ? (
        <ConceptsView
          key={organization.id}
          transport={transport}
          canCreate={allowed('create')}
          canUpdate={allowed('update')}
          canActivate={allowed('activate')}
        />
      ) : (
        <StatePanel state={canonicalStates.find((s) => s.kind === 'forbidden')!} />
      )}
    </section>
  );
}
